import React from 'react';

import { usePagedDocumentsEnabled } from '@oysterjs/ais/components/use-paged-documents-enabled';
import { artifactVersionNumber } from '../lib/artifact';

/** Agencies without the paged document read the bare version, as main shows it. */
export const useArtifactVersionNumber = () => {
  const paged = usePagedDocumentsEnabled();
  return React.useCallback(
    (artifact: { version: number; revision?: number | null }) =>
      paged ? artifactVersionNumber(artifact) : `${artifact.version}`,
    [paged]
  );
};
